export default __webpack_public_path__ + "static/media/header-logo-removebg.b88c5ea6.png";